export default __webpack_public_path__ + "static/media/qualiLogo.ad84d43b.jpg";